/**
 * @generated SignedSource<<5fee069babe86414f37d0484922429f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type stickyChat_fragment$data = {
  readonly unreadThreadCount: number | null | undefined;
  readonly " $fragmentType": "stickyChat_fragment";
};
export type stickyChat_fragment$key = {
  readonly " $data"?: stickyChat_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"stickyChat_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "stickyChat_fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unreadThreadCount",
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};

(node as any).hash = "64ded4244e9b56469b3b4605df30438d";

export default node;
